function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.945312 0.410156 L 19.632812 4.039062 C 20.121094 4.519531 20.121094 5.304688 19.632812 5.78125 L 17.59375 7.789062 L 12.128906 2.417969 L 14.171875 0.410156 C 14.660156 -0.0703125 15.457031 -0.0703125 15.945312 0.410156 Z M 11.554688 8.5 L 11.554688 8.503906 C 11.707031 8.652344 11.78125 8.851562 11.78125 9.042969 C 11.78125 9.238281 11.707031 9.433594 11.554688 9.585938 L 11.550781 9.589844 L 6.601562 14.460938 L 6.597656 14.460938 C 6.554688 14.503906 6.507812 14.539062 6.460938 14.570312 L 6.457031 14.570312 C 6.410156 14.601562 6.359375 14.625 6.304688 14.644531 C 6.03125 14.738281 5.714844 14.675781 5.496094 14.460938 C 5.453125 14.417969 5.417969 14.371094 5.386719 14.324219 C 5.355469 14.273438 5.328125 14.222656 5.3125 14.171875 C 5.214844 13.902344 5.277344 13.589844 5.492188 13.375 L 10.449219 8.5 C 10.601562 8.351562 10.800781 8.277344 11 8.277344 C 11.195312 8.277344 11.394531 8.351562 11.550781 8.5 Z M 7.488281 17.71875 C 6.007812 18.171875 4.53125 18.621094 3.054688 19.070312 C -0.417969 20.128906 -0.40625 20.832031 0.542969 17.539062 L 2.035156 12.359375 L 2.03125 12.351562 L 11.097656 3.433594 L 16.558594 8.808594 L 7.492188 17.726562 Z M 2.96875 13.273438 L 6.554688 16.804688 C 5.585938 17.097656 4.613281 17.394531 3.644531 17.6875 C 1.363281 18.378906 1.371094 18.839844 1.992188 16.679688 Z M 2.96875 13.273438 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.53eb38dddcea137813a131a420dc2445.svg";
export { ForwardRef as ReactComponent };